export const NAV_LINKS = [
  { href: '/', text: 'Главная' },
  { href: '/catalog', text: 'Каталог' },
  { href: '/#services', text: 'Услуги' },
  { href: '/#contacts', text: 'Контакты' },
  { href: '/cart', text: 'Корзина' },
];
